import _objectSpread from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "delDialog-title"
};
import { ref, nextTick, onMounted, computed, getCurrentInstance } from "../../../adapter-vue";
import TUIChatEngine, { TUIStore, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { CONV_OPERATION } from "../../../constant";
import { isPC, isUniFrameWork } from "../../../utils/env";
import { TUIGlobal } from "../../../utils/universal-api/index";
import Overlay from "../../common/Overlay/index.vue";
import Dialog from "../../common/Dialog/index.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: ["actionsMenuPosition", "selectedConversation", "selectedConversationDomRect"],
  emits: ["closeConversationActionMenu"],
  setup: function setup(__props, _ref) {
    var _getCurrentInstance, _props$selectedConver;
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var thisInstance = ((_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) || getCurrentInstance();
    var actionsMenuDomRef = ref();
    var isHiddenActionsMenu = ref(true);
    var isShowDeleteConversationDialog = ref(false);
    var currentConversation = TUIStore.getConversationModel((_props$selectedConver = props.selectedConversation) === null || _props$selectedConver === void 0 ? void 0 : _props$selectedConver.conversationID);
    var _actionsMenuPosition = ref(props.actionsMenuPosition);
    onMounted(function () {
      checkExceedBounds();
    });
    var deleteConversationDialogTitle = computed(function () {
      var _props$selectedConver2, _props$selectedConver3;
      return ((_props$selectedConver2 = props.selectedConversation) === null || _props$selectedConver2 === void 0 ? void 0 : _props$selectedConver2.type) === TUIChatEngine.TYPES.CONV_C2C ? "TUIConversation.删除后，将清空该聊天的消息记录" : ((_props$selectedConver3 = props.selectedConversation) === null || _props$selectedConver3 === void 0 ? void 0 : _props$selectedConver3.type) === TUIChatEngine.TYPES.CONV_GROUP ? "TUIConversation.删除后，将清空该群聊的消息记录" : '';
    });
    function checkExceedBounds() {
      // 组件初始渲染时，执行并自检边界有没有超出屏幕，在nextTick中处理。
      nextTick(function () {
        if (isUniFrameWork) {
          // 处理UniFrameWork菜单低于屏幕的情况
          var query = uni.createSelectorQuery()["in"](thisInstance);
          query.select("#conversation-actions-menu").boundingClientRect(function (data) {
            if (data) {
              var _TUIGlobal$getWindowI;
              if (data.bottom > (TUIGlobal === null || TUIGlobal === void 0 || (_TUIGlobal$getWindowI = TUIGlobal.getWindowInfo) === null || _TUIGlobal$getWindowI === void 0 ? void 0 : _TUIGlobal$getWindowI.call(TUIGlobal).windowHeight)) {
                _actionsMenuPosition.value = _objectSpread(_objectSpread({}, props.actionsMenuPosition), {}, {
                  top: props.actionsMenuPosition.top - props.actionsMenuPosition.conversationHeight - data.height
                });
              }
            }
            isHiddenActionsMenu.value = false;
          }).exec();
        } else {
          var _actionsMenuDomRef$va;
          // 处理原生Vue菜单低于屏幕的情况
          var rect = (_actionsMenuDomRef$va = actionsMenuDomRef.value) === null || _actionsMenuDomRef$va === void 0 ? void 0 : _actionsMenuDomRef$va.getBoundingClientRect();
          // PC端根据鼠标点击的位置设置actionsMenu的位置，否则使用默认值167px
          if (isPC && typeof props.actionsMenuPosition.left !== 'undefined') {
            var _actionsMenuDomRef$va2;
            (_actionsMenuDomRef$va2 = actionsMenuDomRef.value) === null || _actionsMenuDomRef$va2 === void 0 || _actionsMenuDomRef$va2.style.setProperty("left", "".concat(props.actionsMenuPosition.left, "px"));
          }
          if (rect && rect.bottom > window.innerHeight) {
            _actionsMenuPosition.value.top = props.actionsMenuPosition.top - props.actionsMenuPosition.conversationHeight - rect.height;
          }
          isHiddenActionsMenu.value = false;
        }
      });
    }
    var handleItem = function handleItem(params) {
      var name = params.name;
      var conversationModel = currentConversation;
      if (!name || !conversationModel || !conversationModel.conversationID) {
        return;
      }
      switch (name) {
        case CONV_OPERATION.DELETE:
          conversationModel === null || conversationModel === void 0 || conversationModel.deleteConversation();
          break;
        case CONV_OPERATION.ISPINNED:
          conversationModel === null || conversationModel === void 0 || conversationModel.pinConversation();
          break;
        case CONV_OPERATION.DISPINNED:
          conversationModel === null || conversationModel === void 0 || conversationModel.pinConversation();
          break;
        case CONV_OPERATION.MUTE:
          conversationModel === null || conversationModel === void 0 || conversationModel.muteConversation();
          break;
        case CONV_OPERATION.NOTMUTE:
          conversationModel === null || conversationModel === void 0 || conversationModel.muteConversation();
          break;
      }
      emits("closeConversationActionMenu");
    };
    var deleteConversation = function deleteConversation() {
      isShowDeleteConversationDialog.value = true;
    };
    var updateShowDeleteConversationDialog = function updateShowDeleteConversationDialog(isShow) {
      if (!isShow) {
        emits("closeConversationActionMenu");
      }
      isShowDeleteConversationDialog.value = isShow;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Overlay, {
        bgColor: 'transparent',
        onClickHandler: _cache[6] || (_cache[6] = function () {
          return emits('closeConversationActionMenu');
        }),
        onTouchHandler: _cache[7] || (_cache[7] = function () {
          return emits('closeConversationActionMenu');
        })
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", {
            id: "conversation-actions-menu",
            ref_key: "actionsMenuDomRef",
            ref: actionsMenuDomRef,
            "class": _normalizeClass([_unref(isPC) && 'isPC', 'actionsMenu', !_unref(isHiddenActionsMenu) && 'cancelHidden']),
            style: _normalizeStyle({
              top: "".concat(_unref(_actionsMenuPosition).top, "px")
            })
          }, [_createElementVNode("div", {
            "class": _normalizeClass(['actionsMenuItem']),
            onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
              return deleteConversation();
            }, ["stop"]))
          }, _toDisplayString(_unref(TUITranslateService).t("TUIConversation.删除会话")), 1), !props.selectedConversation.isPinned ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            "class": _normalizeClass(['actionsMenuItem']),
            onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
              return handleItem({
                name: _unref(CONV_OPERATION).ISPINNED
              });
            }, ["stop"]))
          }, _toDisplayString(_unref(TUITranslateService).t("TUIConversation.置顶会话")), 1)) : _createCommentVNode("", true), props.selectedConversation.isPinned ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            "class": _normalizeClass(['actionsMenuItem']),
            onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
              return handleItem({
                name: _unref(CONV_OPERATION).DISPINNED
              });
            }, ["stop"]))
          }, _toDisplayString(_unref(TUITranslateService).t("TUIConversation.取消置顶")), 1)) : _createCommentVNode("", true), !props.selectedConversation.isMuted ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            "class": _normalizeClass(['actionsMenuItem']),
            onClick: _cache[3] || (_cache[3] = _withModifiers(function ($event) {
              return handleItem({
                name: _unref(CONV_OPERATION).MUTE
              });
            }, ["stop"]))
          }, _toDisplayString(_unref(TUITranslateService).t("TUIConversation.消息免打扰")), 1)) : _createCommentVNode("", true), props.selectedConversation.isMuted ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            "class": _normalizeClass(['actionsMenuItem']),
            onClick: _cache[4] || (_cache[4] = _withModifiers(function ($event) {
              return handleItem({
                name: _unref(CONV_OPERATION).NOTMUTE
              });
            }, ["stop"]))
          }, _toDisplayString(_unref(TUITranslateService).t("TUIConversation.取消免打扰")), 1)) : _createCommentVNode("", true)], 6), _createVNode(Dialog, {
            show: _unref(isShowDeleteConversationDialog),
            center: true,
            isHeaderShow: _unref(isPC),
            onSubmit: _cache[5] || (_cache[5] = function ($event) {
              return handleItem({
                name: _unref(CONV_OPERATION).DELETE
              });
            }),
            "onUpdate:show": updateShowDeleteConversationDialog
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("p", _hoisted_1, _toDisplayString(_unref(TUITranslateService).t(_unref(deleteConversationDialogTitle))), 1)];
            }),
            _: 1
          }, 8, ["show", "isHeaderShow"])];
        }),
        _: 1
      });
    };
  }
});